import React from 'react';

export const LegalLinks: React.FC = () => (
    <div>
        <a href="https://stackit.de/en/imprint" className="text-dark font-12-300 mr-2" target="_blank">
            Imprint
        </a>
        <a href="https://stackit.de/en/data-protection-notice" className="text-dark font-12-300 mr-2" target="_blank">
            Data Protection
        </a>
        <a href="https://stackit.de/en/compliance" className="text-dark font-12-300 mr-2" target="_blank">
            Compliance
        </a>
        <a
            href="https://stackit.de/en/general-terms-and-conditions"
            className="text-dark font-12-300 mr-2"
            target="_blank"
        >
            Terms and conditions
        </a>
    </div>
);
